import { defineMessages } from 'react-intl-next';

export const i18n: {
	attachedDateLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	attachmentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	pdfLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	videoLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	imageLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	audioLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	attachedDateLabel: {
		id: 'relay.search-result.attachments.attached-date.label',
		defaultMessage: 'Attached {formattedDate}',
		description: 'Indicates the date the attachment was added',
	},
	attachmentLabel: {
		id: 'relay.search-result.attachment-label',
		defaultMessage: 'Attachment',
		description: 'Label for attachment',
	},
	pdfLabel: {
		id: 'relay.search-result.attachments.pdf-label',
		defaultMessage: 'PDF',
		description: 'Label for PDF attachment',
	},
	videoLabel: {
		id: 'relay.search-result.attachments.video-label',
		defaultMessage: 'Video',
		description: 'Label for video attachment',
	},
	imageLabel: {
		id: 'relay.search-result.attachments.image-label',
		defaultMessage: 'Image',
		description: 'Label for image attachment',
	},
	audioLabel: {
		id: 'relay.search-result.attachments.audio-label',
		defaultMessage: 'Audio',
		description: 'Label for audio attachment',
	},
});
